function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.506044,
    height: 31.999998,
    viewBox: "0 0 25.506045 31.999998",
    fill: "none",
    id: "svg22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 25.506044,20.31088 V 12.794473 L 23.516407,10.196891 V 5.8307426 L 17.132988,3.5371329 V 0 H 8.3730569 V 3.5371329 L 1.9896373,5.8307426 V 10.196891 L 0,12.794473 V 20.31088 L 1.9896373,22.991364 0,29.181347 12.766839,31.999999 25.506044,29.181347 23.516407,22.991364 Z",
    fill: "#fff200",
    id: "path2",
    style: {
      strokeWidth: 0.276339
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.766839,22.991364 c 3.525472,0 6.38342,-2.857948 6.38342,-6.38342 0,-3.525471 -2.857948,-6.383419 -6.38342,-6.383419 -3.5254713,0 -6.3834194,2.857948 -6.3834194,6.383419 0,3.525472 2.8579481,6.38342 6.3834194,6.38342 z",
    fill: "#000000",
    id: "path4",
    style: {
      strokeWidth: 0.276339
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/icon-light.f51c6aa4f089e63c12ce42bac6c47041.svg";
export { ForwardRef as ReactComponent };